export default function NotFound() {
   return (
      <main style={{ margin: "100px" }}>
         <div className="backGround"></div>
         <h1>404</h1>
         <p style={{ fontSize: "20px" }}>nie znaleziono strony</p>
      </main>
   );
}